import { useNavigate } from "react-router-dom";
import "./homepage.css";

// Auth is enforced by ProtectedRoute (see App.js), so HomePage can stay purely
// presentational — no need for a duplicate, weaker token check here.
const HomePage = () => {
  const navigate = useNavigate();

  function handleRoomClick() {
    navigate("/rooms");
  }

  return(
    <div className="homepage-container">
        <div className="header">
            <h1 className="title">PowerUpPoker</h1>
        </div>
        <div className="center-content">
            {/* Flame wrapper is a plain unclipped box so the fire pseudo-elements can
                extend past the button's clip-path border. Button itself is unchanged. */}
            <span className="fire-button">
              <button onClick={handleRoomClick} className="room-button">Rooms</button>
            </span>
            <button type="button" className="room-button">PLACEHOLDER</button>
        </div>


    </div>

  ) 
};

export default HomePage;